module.exports = __webpack_public_path__ + "media/svg/ic-caret-down-70786f83.svg";